import { Alert } from "@mui/material";
import { isApplicationEditable } from "../Applications/isApplicationEditable";

export function ApplicationStateWarning({ application, sx }) {
  const isLocked = !isApplicationEditable(application ?? {}, true);
  if (isLocked) {
    return (
      <Alert severity="warning" sx={sx}>
        Application has been locked and is no longer editable - Please contact
        Salt if you have any queries
      </Alert>
    );
  }
  if (application.status !== "active") {
    return (
      <Alert severity="warning" sx={sx}>
        Application is no longer active
      </Alert>
    );
  }
  return false;
}
